export const Types = {
  SIGN_IN_REQUEST: '@auth/SIGN_IN_REQUEST',
  SIGN_IN_SUCCESS: '@auth/SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: '@auth/SIGN_IN_FAILURE',

  SIGN_OUT_REQUEST: '@auth/SIGN_OUT_REQUEST',

  SIGN_OUT: '@auth/SIGN_OUT',

  REGISTER_REQUEST: '@auth/REGISTER_REQUEST',
  REGISTER_SUCCESS: '@auth/REGISTER_SUCCESS',
  REGISTER_FAILURE: '@auth/REGISTER_FAILURE',

  REGISTER_CONFIRMATION_REQUEST: '@auth/REGISTER_CONFIRMATION_REQUEST',
  REGISTER_CONFIRMATION_SUCCESS: '@auth/REGISTER_CONFIRMATION_SUCCESS',
  REGISTER_CONFIRMATION_FAILURE: '@auth/REGISTER_CONFIRMATION_FAILURE',

  PASSWORD_RECOVERY_REQUEST: '@auth/PASSWORD_RECOVERY_REQUEST',
  PASSWORD_RECOVERY_SUCCESS: '@auth/PASSWORD_RECOVERY_SUCCESS',
  PASSWORD_RECOVERY_FAILURE: '@auth/PASSWORD_RECOVERY_FAILURE',

  MFA_REQUEST: '@auth/MFA_REQUEST',
  MFA_SUCCESS: '@auth/MFA_SUCCESS',
  MFA_FAILURE: '@auth/MFA_FAILURE',

  RESEND_EMAIL_REQUEST: '@auth/RESEND_EMAIL_REQUEST',
  RESEND_EMAIL_SUCCESS: '@auth/RESEND_EMAIL_SUCCESS',
  RESEND_EMAIL_FAILURE: '@auth/RESEND_EMAIL_FAILURE',

  CHANGE_PASSWORD_REQUEST: '@auth/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: '@auth/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: '@auth/CHANGE_PASSWORD_FAILURE',
};

export const signInRequest = payload => ({
  type: Types.SIGN_IN_REQUEST,
  payload,
});

export const signInSuccess = (token, refreshToken) => ({
  type: Types.SIGN_IN_SUCCESS,
  payload: {
    token,
    refreshToken,
  },
});

export const signInFailure = () => ({
  type: Types.SIGN_IN_FAILURE,
});

export const signOutRequest = () => ({
  type: Types.SIGN_OUT_REQUEST,
});

export const signOut = () => ({
  type: Types.SIGN_OUT,
});

export const registerRequest = payload => ({
  type: Types.REGISTER_REQUEST,
  payload,
});

export const registerSuccess = () => ({
  type: Types.REGISTER_SUCCESS,
});

export const registerFailure = () => ({
  type: Types.REGISTER_FAILURE,
});

export const registerConfirmationRequest = payload => ({
  type: Types.REGISTER_CONFIRMATION_REQUEST,
  payload,
});

export const registerConfirmationSuccess = () => ({
  type: Types.REGISTER_CONFIRMATION_SUCCESS,
});

export const registerConfirmationFailure = () => ({
  type: Types.REGISTER_CONFIRMATION_FAILURE,
});

export const passwordRecoveryRequest = payload => ({
  type: Types.PASSWORD_RECOVERY_REQUEST,
  payload,
});

export const passwordRecoverySuccess = () => ({
  type: Types.PASSWORD_RECOVERY_SUCCESS,
});

export const passwordRecoveryFailure = () => ({
  type: Types.PASSWORD_RECOVERY_FAILURE,
});

export const mfaRequest = payload => ({
  type: Types.MFA_REQUEST,
  payload,
});

export const mfaSuccess = () => ({
  type: Types.MFA_SUCCESS,
});

export const mfaFailure = () => ({
  type: Types.MFA_FAILURE,
});

export const resendEmailRequest = payload => ({
  type: Types.RESEND_EMAIL_REQUEST,
  payload,
});

export const resendEmailSuccess = () => ({
  type: Types.RESEND_EMAIL_SUCCESS,
});

export const resendEmailFailure = () => ({
  type: Types.RESEND_EMAIL_FAILURE,
});

export const changePasswordRequest = payload => ({
  type: Types.CHANGE_PASSWORD_REQUEST,
  payload,
});

export const changePasswordSuccess = () => ({
  type: Types.CHANGE_PASSWORD_SUCCESS,
});

export const changePasswordFailure = () => ({
  type: Types.CHANGE_PASSWORD_FAILURE,
});
